<template>
  <va-edit-layout>
    <specialties-form :id="id" :title="title" :item="item"></specialties-form>
  </va-edit-layout>
</template>

<script>
export default {
  props: ["id", "title", "item"],
};
</script>
